import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { injectKeyHandler, Keys } from '@zocdoc/components/src/KeyHandler';
import { ModalOverlay } from '@zocdoc/components/src/modal';
import { InteractionLabels } from '../../../middleware/google-analytics';
import { breakpoint } from '@zocdoc/components/src/grid';
import hoistNonReactStatic from 'hoist-non-react-statics';
import getDisplayName from '../../../utils/displayName';

const Wrapper = styled.div`
    height: 100%;
`;

const StyledOverlay = styled(ModalOverlay)`
    opacity: ${props => props.spotlightIsOn ? '0.6' : '0'};
    visibility: ${props => props.spotlightIsOn ? 'visible' : 'hidden'};
    transition: 0.5s;
    z-index: auto;

    display: none;
    ${breakpoint.medium} {
        display: block;
    }
`;

export default function withSpotlight(WrappedComponent) {
    class BaseWithSpotlightEnabled extends PureComponent {
        static displayName = `WithSpotlightEnabled(${getDisplayName(WrappedComponent)})`;
        static WrappedComponent = WrappedComponent;

        static propTypes = {
            spotlightIsOn: PropTypes.bool.isRequired,
            onClickSpotlightOverlay: PropTypes.func.isRequired,
            onClickWrappedComponent: PropTypes.func.isRequired,
        };

        render() {
            const { spotlightIsOn, onClickSpotlightOverlay, onClickWrappedComponent } = this.props;

            return (
                <Wrapper data-test="with-spotlight-component">
                    <div
                        data-test="spotlight-overlay-container"
                        onClick={onClickSpotlightOverlay}
                        role="presentation"
                    >
                        <StyledOverlay
                            data-test="spotlight-overlay"
                            spotlightIsOn={spotlightIsOn}
                        />
                    </div>
                    <WrappedComponent
                        {...this.props}
                        onClick={onClickWrappedComponent}
                    />
                </Wrapper>
            );
        }
    }

    const WithSpotlightEnabled = injectKeyHandler({
        [Keys.ESCAPE]: ({ onClickSpotlightOverlay }) => {
            onClickSpotlightOverlay({ interaction: InteractionLabels.Keyboard });
        },
    })(BaseWithSpotlightEnabled);

    return hoistNonReactStatic(WithSpotlightEnabled, WrappedComponent);
}
